import { render, staticRenderFns } from "./LearningGoalResult.vue?vue&type=template&id=5097c651&"
import script from "./LearningGoalResult.vue?vue&type=script&lang=js&"
export * from "./LearningGoalResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports